import {Component, ElementRef, Input, OnChanges, OnDestroy, OnInit, SimpleChanges, ViewChild} from '@angular/core';
import Editor from '@toast-ui/editor';
import Viewer from '@toast-ui/editor/dist/toastui-editor-viewer';
import '@toast-ui/editor/dist/i18n/de-de'


const TOOLBAR_ITEMS = [
  ['heading', 'bold', 'italic', 'strike'],
  ['hr', 'quote'],
  ['ul', 'ol', 'task', 'indent', 'outdent']];


Editor.setLanguage(['de-DE'], {
  Markdown: 'Markdown',
  WYSIWYG: 'Text',
});

@Component({
  selector: 'app-markdown-editor',
  imports: [],
  templateUrl: './markdown-editor.component.html',
  styleUrl: './markdown-editor.component.scss'
})

export class MarkdownEditorComponent implements OnInit, OnChanges, OnDestroy {
  @ViewChild('container', { static: true }) containerRef!: ElementRef;

  // Content and readonly control
  @Input() readonly = true;
  @Input() content = '## Hier wird noch gearbeitet...';

  private editor?: Editor;
  private viewer?: Viewer;

  ngOnInit() {
    this.render();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['readonly'] && !changes['readonly'].firstChange) {
      this.render(); // Re-render based on new readonly state
    }
    if (changes['content'] && !changes['content'].firstChange) {
      if (this.readonly && this.viewer) {
        this.viewer.setMarkdown(this.content);
      } else if (!this.readonly && this.editor) {
        this.editor.setMarkdown(this.content);
      }
    }
  }

  ngOnDestroy() {
    this.destroyAll();
  }

  private destroyAll() {
    this.editor?.destroy();
    this.viewer?.destroy();
    this.editor = undefined;
    this.viewer = undefined;
  }

  private render() {
    this.destroyAll();
    if (this.readonly) {
      this.viewer = new Viewer({
        el: this.containerRef.nativeElement,
        initialValue: this.content,
        language: 'de-DE',
        height: 'auto'
      });
    } else {
      this.editor = new Editor({
        el: this.containerRef.nativeElement,
        initialEditType: 'markdown',
        previewStyle: 'vertical',
        initialValue: this.content,
        toolbarItems: TOOLBAR_ITEMS,
        language: 'de-DE',
        height: 'auto'
      });
    }
  }

  public getMarkdown(): string {
    if (!this.readonly && this.editor) {
      return this.editor.getMarkdown();
    }
    return '';
  }
}
